import { api as AxiosRepository } from "./AxiosRepository";
const apiVersionBaseUrl = "/v1/alliances";

export default {
  getAlliances() {
    return AxiosRepository.get(apiVersionBaseUrl).then((response) => response.data);
  }
};
